
import "./Blog.css";
import { Link } from "react-router-dom";
import SEO from '../components/seo/SEO';
import { useState } from 'react';
import { MdChevronRight, MdArticle, MdFolder } from "react-icons/md";

const reviewItems = [
    { to: "/review/VideoEditors", label: "Video Editors" },
    { to: "/review/SmartPhones", label: "Smartphones" },
];

export default function Blog() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <SEO
                title="Blog | Explorelrt"
                description="Explore blogs from Explorelrt, including practical technical learning paths and networking study material."
            />

            <div className="blogContainer">


                <section className="blogIntro">
                    <p>Welcome to the Blog! you can find a variety of articles and reviews.</p>

                </section>

                <section className="Blog">

                        <div className="blogPanel">
                            <button
                                type="button"
                                onClick={() => setOpen((expand) => !expand)}
                                className="blogHeaderButton"
                                aria-expanded={open}
                                aria-controls="blog-list"
                            >
                                <span className="blogHeaderTitle">
                                    <MdFolder aria-hidden="true" />
                                    <span>Review</span>
                                </span>
                                <MdChevronRight
                                    className={`blogToggleIcon ${open ? "open" : ""}`}
                                    aria-hidden="true"
                                />
                            </button>
                            { open && 
                                <div className="blogList" id="blog-list">
                                    {reviewItems.map((item) => (
                                        <Link key={item.to} to={item.to}>
                                            <span className="blogListTitle">
                                                <MdArticle aria-hidden="true" />
                                                <span>{item.label}</span>
                                            </span>
                                            <MdChevronRight className="blogListArrow" aria-hidden="true" />
                                        </Link>
                                    ))}
                                </div>
                            }
                    </div>
                </section>
            </div>
        </>
    );
}
